import Type from './Type';
export function isIContainer(node) {
    return node.type === Type.Container;
}
export default isIContainer;    //# sourceMappingURL=isIContainer.js.map
